import React from 'react';
import { Crisp } from "crisp-sdk-web"
import { useHistory, useParams } from 'react-router-dom';
import { Radio, MessageCircle, Plus, ArrowRight } from 'lucide-react';
import { useIntegration } from '../../http-hooks/integration/useIntegration';
import { Card } from '../../components/ui/bootstrap';

function PodcastsEmptyState() {
    const history = useHistory();
    const { org_id, id } = useParams();
    const { data: integration } = useIntegration({ org_id, integration_id: id });

    return (
        <div className="d-flex flex-column gap-4">
            {/* Hero empty state */}
            <Card className="rounded-4 p-5 text-center" shadow>
                <div
                    className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
                    style={{ width: 64, height: 64, background: 'rgba(var(--bs-primary-rgb), 0.08)' }}
                >
                    <Radio size={28} color="var(--bs-primary)" strokeWidth={1.5} />
                </div>
                <h5 className="fw-bold mb-2 text-body-emphasis">Showcase your audio as a podcast</h5>
                <p className="text-muted mb-4 mx-auto" style={{ fontSize: '0.9rem', maxWidth: 480 }}>
                    Embed a beautiful podcast page on your site, or publish directly to Spotify, Apple Podcasts and Google Podcasts — all from one place.
                </p>
                {integration?.gates?.can_create_audio && (
                    <button
                        className="btn fw-semibold d-inline-flex align-items-center gap-2"
                        onClick={() => history.push(`/organisation/${org_id}/integration/${id}/podcast/new`)}
                        style={{
                            background: 'linear-gradient(135deg, var(--bs-primary) 0%, var(--bs-secondary) 100%)',
                            color: 'white', borderRadius: 50, padding: '10px 28px', border: 'none', fontSize: 14,
                        }}
                    >
                        <Plus size={16} /> Create your first podcast
                    </button>
                )}
            </Card>
            <div
                className="rounded-4 p-4 d-flex align-items-center justify-content-between gap-4 flex-wrap"
                style={{
                    background: 'linear-gradient(135deg, var(--bs-primary) 0%, var(--bs-secondary) 100%)',
                    boxShadow: '0 8px 32px rgba(var(--bs-primary-rgb), 0.25)',
                }}
            >
                <div className="d-flex align-items-center gap-3">
                    <div className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 40, height: 40, background: 'rgba(255,255,255,0.2)' }}>
                        <MessageCircle size={20} color="white" strokeWidth={1.75} />
                    </div>
                    <div>
                        <p className="fw-bold text-white mb-0" style={{ fontSize: '0.95rem' }}>Having trouble publishing your podcast?</p>
                        <p className="mb-0 text-white" style={{ opacity: 0.85, fontSize: '0.8rem' }}>Our team is happy to help you get set up.</p>
                    </div>
                </div>
                <button
                    type="button"
                    className="btn fw-semibold flex-shrink-0 d-flex align-items-center gap-2"
                    onClick={() => Crisp.chat.open()}
                    style={{ background: 'white', color: 'var(--bs-primary)', borderRadius: 50, padding: '9px 22px', fontSize: 13, border: 'none' }}
                >
                    Contact Us <ArrowRight size={15} />
                </button>
            </div>
        </div>
    );
}

export default PodcastsEmptyState;

